export default __webpack_public_path__ + "static/media/history.ko-2.6a159b9f.png";